// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcp_a bhi_ea bhi_kb bhi_js bhi_sl bhi_wj"};